// @flow
import type {
  Image,
} from '../types';

const getContentIconUrl = (image?: ?Image) => (image && image.url && image.id !== 'dummyid' ? image.url : null);

export {
  // eslint-disable-next-line import/prefer-default-export
  getContentIconUrl,
};
